module.exports = __webpack_public_path__ + "static/media/logo.953798db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/icons/logo.svg
// module id = 56
// module chunks = 0